import { useTranslation } from 'react-i18next';
import { ErrorRow } from '../ErrorRow';
import { LoadingRow } from '../LoadingRow';

export function NoResultsRow({
  isSearchPoliciesLoading,
  isSearchPoliciesError,
  pageSize,
}: {
  isSearchPoliciesLoading: boolean;
  isSearchPoliciesError: boolean;
  pageSize: number;
}) {
  const { t } = useTranslation();

  if (isSearchPoliciesLoading) {
    return Array.from({ length: pageSize }).map((_, index) => (
      <LoadingRow
        // biome-ignore lint/suspicious/noArrayIndexKey: is ok
        key={`loading-row-${index}`}
      />
    ));
  }

  if (isSearchPoliciesError) {
    return <ErrorRow>{t('policyTable.fetchError')}</ErrorRow>;
  }

  return <ErrorRow>{t('policyTable.noResults')}</ErrorRow>;
}
